import { Slide } from '@features/powerpoint';
import { TITLE } from '../../shared/dark-background-slide-master';
import { theme } from '@features/lci-report/domain/theme';

export const talkToUsSlide = (): Slide => ({
  slideMaster: TITLE,
  texts: [
    {
      text: [
        { text: 'Talk to us!', options: { breakLine: true } },
        { text: "We're here for you." },
      ],
      options: {
        fontSize: theme.fontSizes.h1,
        color: theme.colors.white,
        bold: true,
        h: 0.98,
        w: 5.1,
        x: 0.76,
        y: 3.75,
      },
    },
  ],
});
